import { Component, EventEmitter, Inject, OnDestroy, OnInit, Output, TemplateRef, ViewChild, DOCUMENT } from '@angular/core';
import { Subscription } from 'rxjs';
import { AggregationService } from 'src/app/_services/aggregation.service';
import { AiSourcingService } from 'src/app/_services/ai-sourcing.service';
import { PersonSearchService } from 'src/app/_services/person-search.service';
import * as _ from 'underscore';

import { FilterDataHandlerService } from 'src/app/_services/filter-data-handler.service';
import { UntypedFormControl, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CampaignService } from 'src/app/_services/campaign.service';
import { LocalStorageService } from 'src/app/_services/local-storage.service';
import { CandidateService } from 'src/app/_services/candidate.service';
import { BulkRevealModalComponent } from 'src/app/bulk-reveal-modal/bulk-reveal-modal.component';
import { AiSourcingHandlerService } from 'src/app/_services/ai-sourcing-handler.service';

import { Router } from '@angular/router';
import { ArchiveCandidateModalComponent } from '../archive-candidate-modal/archive-candidate-modal.component';
import { BulkEmailCampaignComponent } from '../bulk-email-campaign/bulk-email-campaign.component';
import { HttpErrorResponse } from '@angular/common/http';
declare const clevertap;
@Component({
    selector: 'app-ai-sourcing-shortlist',
    templateUrl: './ai-sourcing-shortlist.component.html',
    styleUrls: ['./ai-sourcing-shortlist.component.scss'],
    standalone: false
})
export class AiSourcingShortlistComponent implements OnInit, OnDestroy {
  projectNumber: string;
  shortlistedProfiles: any[] = [];
  tabType: string = 'autopilotTab';
  currentCandidate: any;
  currentIndex: number;
  showCandidate: boolean = false;
  viewMoreSkills: boolean = false;
  subscriptions: Array<Subscription> = [];
  selectedCandididate: any[] = [];
  campaign_input = new UntypedFormControl(null, [Validators.required]);
  @ViewChild('addCandidateToEmailCampaign') addCandidateToEmailCampaign: TemplateRef<any>;
  isLoadingEmailCampaignApi: boolean = false;
  selectedCampaign: any;
  emailFoundCount: number;
  campaignList: any;
  @Output() refreshCurrentView: EventEmitter<any> = new EventEmitter();
  successMessage: string = '';
  errorMessage: string = '';
  showLoaderbeforeDataLoad: boolean = false;
  totalCandidatesCount: number = 0;
  projectDetails: any;
  showShortlistRevaluate: string = '';
  currentPage: number = 1;

  constructor(
    private aggregationService: AggregationService,
    private aiSourcingService: AiSourcingService,
    private filterDataHandlerService: FilterDataHandlerService,
    private personSearchService: PersonSearchService,
    private modalService: NgbModal,
    private emailCampaignService: CampaignService, private _localStorageService: LocalStorageService, private candidateservice: CandidateService,
    private aiSourcingHandlerService: AiSourcingHandlerService, private router: Router,
    @Inject(DOCUMENT) private document: Document) {
    const filterMethodEvent = this.filterDataHandlerService.filterMethodEvent.subscribe(_methodDetails => {
      if (window.location.pathname.includes('ai-sourcing-profiles/shortlist')) {
        if (_methodDetails.methodName == 'clearFilters') {
          if (_methodDetails.source && _methodDetails.source == 'tabChange') {
            return;
          } else {
            this.getShortlistedProfiles();
          }
        } else { // custom fla
          this.getShortlistedProfiles();
        }
      }
    });
    this.subscriptions.push(filterMethodEvent);


  }

  ngOnInit() {
    this.projectNumber = window.location.pathname?.split('/')[4];
    this.getShortlistedProfiles();
    const getSelectedAllCandidateEvent = this.aiSourcingService.getSelectAllCandidateEvent.subscribe(res => {
      if (res?.clearAll) {
        this.selectedCandididate = [];
        const selectedIds = new Set(this.selectedCandididate.map((c: any) => c.id));
        this.shortlistedProfiles = (this.shortlistedProfiles).map((candidate: any) => ({
          ...candidate,
          selected: selectedIds.has(candidate.id)
        }));
      } else if (res?.tab == 'shortlist') {
        this.bulkSelectCandidate(res);
      }
    });
    this.subscriptions.push(getSelectedAllCandidateEvent);
    const refreshListEvent = this.aiSourcingService.getRefreshListEvent.subscribe(res => { this.refreshList(res) });
    this.subscriptions.push(refreshListEvent);
    this.projectDetails = this.aiSourcingHandlerService.fetchProjectDetails;
    setTimeout(() => {
      const filterRow = document.querySelector<HTMLElement>("#topShortlist");
      if (filterRow) {
        const y = filterRow.getBoundingClientRect().top + window.scrollY - 200;
        window.scrollTo({ top: y, behavior: "smooth" });
      }
    }, 0);
  }

  getShortlistedProfiles() {
    this.showLoaderbeforeDataLoad = true;
    const requestObject = this.aggregationService.getRequestWithFilters();
    requestObject['candidatetype'] = 'shortlisted';
    requestObject['pagesize'] = 20;
    requestObject['page'] = this.currentPage;
    requestObject.continentstobeincluded = [];

    this.aiSourcingService.getCandidateList(requestObject, this.projectNumber).subscribe(
      (response: any) => {
        if (response && response.data) {
          this.showLoaderbeforeDataLoad = false;
          this.shortlistedProfiles = response.data.results || [];
          this.totalCandidatesCount = response.data.candidatecount || 0;
          this.aiSourcingHandlerService.setProjectCountEvent({ tab: 'shortlist', count: this.totalCandidatesCount });

          const selectedIds = new Set(this.selectedCandididate.map((c: any) => c.id));
          this.shortlistedProfiles = (response.data.results || []).map((candidate: any) => ({
            ...candidate,
            selected: selectedIds.has(candidate.id)
          }));
          this.aiSourcingService.emitCandidateListEvent(response.data);
        } else {
          this.showLoaderbeforeDataLoad = false;
          this.shortlistedProfiles = [];
        }
      }
    )
  }


  eventHandler(event) {
    if (event.action == 'success') {
      if (event.status == 'archive') {
        this.successMessage = 'Candidate successfully archived';
        setTimeout(() => {
          this.successMessage = '';
        }, 5000);
        this.getShortlistedProfiles();
      }
    } else {
      setTimeout(() => {
        if (event && event.data && event.data.currentIndex >= 0) {
          event.data.lastseencount = 1;
          this.shortlistedProfiles[event.data.currentIndex].lastseencount = 1
        }
      }, 1000)

      var val = event.data.idinindex
      this.shortlistedProfiles.find(function (item, i) {
        if (item.idinindex === val) {
          index = i;
          return i;
        }
      });

      var index = -1;

      if (event.action == 'append-data' && event.data != undefined && typeof event.data == 'object') {
        // this.candidateList[event.data.currentIndex] = event.data

        var val = event.data.idinindex
        this.shortlistedProfiles.find(function (item, i) {
          if (item.idinindex === val) {
            index = i;
            return i;
          }
        });
        if (event.data && event.data.existingContactDetails) {
          this.shortlistedProfiles[index]['existingContactDetails'] = event.data.existingContactDetails;
          this.shortlistedProfiles[index]['candidatenumber'] = event.data.candidatenumber;
          this.shortlistedProfiles[index] = Object.assign([], this.shortlistedProfiles[index]);

        } else {
          this.shortlistedProfiles[index]['existingContactDetails'] = [];
           this.shortlistedProfiles[index]['candidatenumber'] = [];

        }
        if (event.data && event.data.iswebbtreeverified) {
          this.shortlistedProfiles[index]['iswebbtreeverified'] = 1;
        }

        if (event.data && event.data.usedWebbtreeIntroduction) {
          this.shortlistedProfiles[index]['usedWebbtreeIntroduction'] = 1;
        }
        if (event.data && event.data.revealContactAttempted) {
          this.shortlistedProfiles[index]['revealContactAttempted'] = 1;
        }

      }

      const loadn = document.querySelectorAll<HTMLElement>('.loading-screen-wrapper');

      if (event.action == 'openNav') {
        //loadn[0].style.display = 'none'
        if (event.type == 'show-contact') {
          this.tabType = 'contactTab'
        } else if (event.type == 'show-activity') {
          this.tabType = 'activityTab'
        } else if (event.type == 'show-skills') {
          this.tabType = 'profileTab'
          this.viewMoreSkills = true;
        }
        else {
          this.tabType = 'autopilotTab'
        }

        if (event.data && event.data.experience && event.data.experience.length  && event.data.experience[0].company) {
          const companyObjects = _.pluck(event.data.experience, 'company');
          const payload = companyObjects.map(item => {
            if (item?.id || item?.name) {
              return {
                ...(item?.id && { id: item?.id }),
                ...(item?.name && { name: item?.name })
              }
            }
          }).filter(Boolean);

          this.personSearchService.getCompanyLogoV2(payload).subscribe((res: any) => {
            if (res && res.status == "success") {
              const resultName = res.data
              resultName.forEach(obj => {
                const matchingObj = event.data.experience.filter((item) => ((obj.searchedVia === 'id' && obj.key === item.id) || (obj.searchedVia === 'name' && obj.key === item.name)));
                if (matchingObj && matchingObj.length) {
                  let companyLogo = obj.companylogo
                  matchingObj.forEach(x => {
                    x.companylogo = companyLogo;
                  })

                }
              });

              this.openCandidateSlider(index == -1 ? event.data : this.shortlistedProfiles[index], event.currentIndex)
            } else {
              this.openCandidateSlider(index == -1 ? event.data : this.shortlistedProfiles[index], event.currentIndex)
            }
          });
        } else {
          this.openCandidateSlider(index == -1 ? event.data : this.shortlistedProfiles[index], event.currentIndex)
          //loadn[0].style.display = 'none'
        }



      } else if (event.action == 'closeNav') {
        this.closeNav();
      }
    }


    // this.getLastActivity(event.data.idinindex)
  }

  openCandidateSlider(data, currentIndex) {
    this.currentCandidate = data;
    this.currentIndex = data.currentIndex
    this.showCandidate = true;
    document.getElementById("quickView").style.width = "55%";
    document.getElementById("quickView").style.right = "0";
    document.getElementById("overlay").style.display = "block";
    const loadn = document.querySelectorAll<HTMLElement>('.loading-screen-wrapper');
    //loadn[0].style.display = 'none'
  }

  closeNav() {
    this.viewMoreSkills = false;
    this.showCandidate = false
    document.getElementById("quickView").style.width = "0";
    document.getElementById("overlay").style.display = "none";
    document.getElementById("quickView").style.right = "-50px";
    const loadn = document.querySelectorAll<HTMLElement>('.loading-screen-wrapper');
    //loadn[0].style.display = 'block'
  }

  bulkSelectCandidate(res: any) {
    if (res.selectAll == true) {
      this.shortlistedProfiles.forEach((candidate) => {
        candidate.selected = true;
        this.selectedCandididate.push(candidate);
      });

    } else {
      this.shortlistedProfiles.forEach((candidate) => {
        candidate.selected = false;
        this.selectedCandididate = this.selectedCandididate.filter(x => x.id !== candidate.id)
      });
    }
    this.aiSourcingService.emitCandidateEvent(this.selectedCandididate);
  };

  selectCandidate(event: any, candidate: any) {
    const value = (event.target as HTMLInputElement) && (event.target as HTMLInputElement).checked ? true : false;
    if (value) {
      candidate.selected = true;
      event.target.checked = true;
      this.selectedCandididate.push(candidate)
    } else {
      candidate.selected = false;
      event.target.checked = false;
      this.selectedCandididate = this.selectedCandididate.filter(x => x.id !== candidate.id);
    }
    this.aiSourcingService.emitCandidateEvent(this.selectedCandididate);
  }

  openAddToEmailCampaign() {
    const modalRef = this.modalService.open(this.addCandidateToEmailCampaign, { size: 'xs' as 'lg', centered: true, backdrop: 'static', keyboard: false });
  }

  onCampaignSelected(value): void {
    this.selectedCampaign = value;
    this.campaign_input.setValue(value.campaign_name);
  }
  addToEmailCampaign() {
    this.isLoadingEmailCampaignApi = true;
    this.campaign_input.markAllAsTouched();
    if (this.campaign_input.valid && this.selectedCampaign) {
      const campaign_id = this.selectedCampaign.campaign_id;
      let unsubscribedCandidateCount = 0;
      let payloadArray = (Array.isArray(this.currentCandidate) ? this.currentCandidate : [this.currentCandidate]).map(x => {
        if (x?.is_unsubscribed) {
          unsubscribedCandidateCount++;
          return;
        }
        return {
          firstname: x.first_name,
          target_name: x.full_name,
          target_id: null,
          target_meta: JSON.stringify({
            "candidatenumber": x.candidatenumber && x.candidatenumber.length ? x.candidatenumber : null,
            "elastic_id": x.id,
            "title": x.job_title,
          }),

          //elastic || else send 0
          target_email: x.existingContactDetails && x.existingContactDetails.length ?
            this.extractPreferredEmail(x.existingContactDetails) : null,

          is_active: true,
          created_on: new Date().toISOString(),
          updated_on: new Date().toISOString(),
          projectnumber: this.projectNumber,
        };
      }).filter(Boolean);
      const updatedPayloadArray = payloadArray.filter(x => x);
      this.emailFoundCount = 0;
      updatedPayloadArray.forEach(element => {
        if (element.target_email)
          this.emailFoundCount++;
      }
      );

      if (unsubscribedCandidateCount > 0 && updatedPayloadArray.length === 0) {
        this.closeActiveModal();
        this.toastmessage("Unsubscribed from Email Campaign", 'error');
        return;
      }
      const payload = {
        elasticids: [this.currentCandidate.id],
        projectnumber: this.projectNumber
      }


      if (this.currentCandidate.existingContactDetails.length && this.currentCandidate.existingContactDetails.some(x => x.type === 'email')) {
        this.aiSourcingService.aiSourcingMigrate(payload).subscribe((res: any) => {
          const newMeta = JSON.parse(updatedPayloadArray[0].target_meta);
          newMeta.candidatenumber = res.data[0].candidatenumber;
          updatedPayloadArray[0].target_meta = JSON.stringify(newMeta);
          this.emailCampaignService.createTarget(campaign_id, updatedPayloadArray).subscribe((res: any) => {
            this.isLoadingEmailCampaignApi = false;
            if (res.status == 'success') {
              if (res.data && res.data.length) {
                this.refreshCurrentView.emit(this.currentCandidate);
                this.showEmailCampaignCount();
                this.addEmailCampaignActivity(res.data);
                  this.closeActiveModal();

                this.toastmessage("Candidate added to email campaign successfully", 'success');
              } else {
                this.closeActiveModal();
                this.toastmessage("Candidate already present in selected campaign", 'error');
              }
            } else {
              this.closeActiveModal()
              this.toastmessage("candidate addition failed", "error");
            }

                 /**
          * Click on To add to EmailCampaign button
          */
         const emailCampaignParams = {
          "User ID": this._localStorageService.getItem('userdata').userid,
          "Project Number": this.projectNumber,
          "Called From": "Shortlist Slider",
          "ElasticId": this.currentCandidate.id

        }
        clevertap.event.push("Autopilot-Add To Email Campaign Candidate",emailCampaignParams);

          }, (error: HttpErrorResponse) => {
              this.isLoadingEmailCampaignApi = false;
              if (error.status === 400 && error.error && Reflect.has(error.error, 'remainingTargets')) {
                const remainingTargets = error.error.remainingTargets;
                this.toastmessage(`Only ${remainingTargets} candidate(s) can be added to the campaign as you are nearing the campaign limit`, "error");
              } else {
                this.toastmessage("Something went wrong", "error");
              }
              this.closeActiveModal();
            });
        })
      } else {
        Promise.all(updatedPayloadArray.map(async (x: any) => {
          x.target_email = await this.getContactDetails(this.currentCandidate.id, this.selectedCampaign['email_pref']);
          return x;
        })).then((newPayload) => {
          this.aiSourcingService.aiSourcingMigrate(payload).subscribe((res: any) => {
            const newMeta = JSON.parse(updatedPayloadArray[0].target_meta);
            newMeta.candidatenumber = res.data[0].candidatenumber;
            updatedPayloadArray[0].target_meta = JSON.stringify(newMeta);
            if (newPayload[0].target_email) {
              this.emailCampaignService.createTarget(campaign_id, newPayload).subscribe((res: any) => {
                this.isLoadingEmailCampaignApi = false;
                if (res.status == 'success') {
                  if (res.data && res.data.length) {

                    this.refreshCurrentView.emit(this.currentCandidate);
                    this.addEmailCampaignActivity(res.data);
                    this.showEmailCampaignCount()
                    this.toastmessage("Candidate added to email campaign successfully", 'success');
                    this.closeActiveModal();
                  } else {
                    this.closeActiveModal()

                    this.toastmessage("Candidate already present in selected campaign", 'error')
                  }
                } else {
                  this.closeActiveModal()
                  this.toastmessage("candidate addition failed", "error");
                }
                   /**
          * Click on To add to EmailCampaign button
          */
         const emailCampaignParams = {
          "User ID": this._localStorageService.getItem('userdata').userid,
          "Project Number": this.projectNumber,
          "Called From": "Shortlist Slider",
          "ElasticId": this.currentCandidate.id

        }
        clevertap.event.push("Autopilot-Add To Email Campaign Candidate",emailCampaignParams);
              }, (error: HttpErrorResponse) => {
                this.isLoadingEmailCampaignApi = false;
                if (error.status === 400 && error.error && Reflect.has(error.error, 'remainingTargets')) {
                  const remainingTargets = error.error.remainingTargets;
                  this.toastmessage(`Only ${remainingTargets} candidate(s) can be added to the campaign as you are nearing the campaign limit`, "error");
                } else {
                  this.toastmessage("Something went wrong", "error");
                }
                this.closeActiveModal();
              });
            } else {
              this.emailCampaignService.createTarget(campaign_id, updatedPayloadArray).subscribe((res: any) => {
                this.isLoadingEmailCampaignApi = false;
                if (res.status == 'success') {
                  if (res.data && res.data.length) {
                    this.refreshCurrentView.emit(this.currentCandidate);
                    this.addEmailCampaignActivity(res.data);
                    this.closeActiveModal()

                    this.showEmailCampaignCount();
                    this.openEmailCampaignModal(campaign_id);
                  } else {
                    this.closeActiveModal()

                    this.toastmessage("Candidate already present in selected campaign", 'error')
                  }
                } else {
                  this.closeActiveModal()
                  this.toastmessage("candidate addition failed", "error");

                }
                   /**
          * Click on To add to EmailCampaign button
          */
         const emailCampaignParams = {
          "User ID": this._localStorageService.getItem('userdata').userid,
          "Project Number": this.projectNumber,
          "Called From": "Shortlist Slider",
          "ElasticId": this.currentCandidate.id

        }
        clevertap.event.push("Autopilot-Add To Email Campaign Candidate",emailCampaignParams);
              }, (error: HttpErrorResponse) => {
                this.isLoadingEmailCampaignApi = false;
                if (error.status === 400 && error.error && Reflect.has(error.error, 'remainingTargets')) {
                  const remainingTargets = error.error.remainingTargets;
                  this.toastmessage(`Only ${remainingTargets} candidate(s) can be added to the campaign as you are nearing the campaign limit`, "error");
                } else {
                  this.toastmessage("Something went wrong", "error");
                }
                this.closeActiveModal();
              });
            }
          })
        })




      }
    }
  }

  extractPreferredEmail(details) {
    let emailPref = this.selectedCampaign['email_pref'];
    let personalPref_email = [];
    let professionalPref_email = [];
    let targetEmailFound = '';
    const existingContactDetails = details?.filter(x => x.type === 'email');
    if (existingContactDetails && existingContactDetails.length) {

      personalPref_email = existingContactDetails.filter(x => x.contactdetailcategory == 'personal')
      professionalPref_email = existingContactDetails.filter(x => x.contactdetailcategory == 'professional')

      switch (emailPref) {
        case 1: targetEmailFound = personalPref_email.length ? personalPref_email[0].contactdetail : '';
          break;
        case 2: targetEmailFound = professionalPref_email.length ? professionalPref_email[0].contactdetail : '';
          break;
        case 3: targetEmailFound = personalPref_email.length ? personalPref_email[0].contactdetail : professionalPref_email.length ? professionalPref_email[0].contactdetail : '';
          break;
        case 4: targetEmailFound = professionalPref_email.length ? professionalPref_email[0].contactdetail : personalPref_email.length ? personalPref_email[0].contactdetail : '';
          break;
      }
    }
    return targetEmailFound;
  }

  closeActiveModal() {
    this.campaign_input.markAsUntouched();
    this.campaign_input.markAsPristine();
    this.campaign_input.reset();
    this.modalService.dismissAll()
  }
  toastmessage(message, type) {
    if (type == 'success') {
      this.successMessage = message;
      setTimeout(() => this.successMessage = '', 5000);
    } else if (type == 'error')
      this.errorMessage = message;
    setTimeout(() => this.errorMessage = '', 5000);
  }

  openDetailsModal(campaign_id, payload, emailsFound, total_target) {
    const modalRef = this.modalService.open(BulkRevealModalComponent, { size: 'xs' as 'lg', centered: true });
    modalRef.componentInstance.campaign_id = campaign_id;
    modalRef.componentInstance.payload = payload;
    modalRef.componentInstance.emailsFound = emailsFound;
    modalRef.componentInstance.campaignDetails = this.selectedCampaign;
    modalRef.componentInstance.total_target = total_target;
    modalRef.componentInstance.calledFor = 'email-campaign';
  }


  showEmailCampaignCount() {
    if (this.currentCandidate && this.currentCandidate.emailcampaigncount >= 1) {
      this.currentCandidate.emailcampaigncount = this.currentCandidate.emailcampaigncount + 1
    } else {
      this.currentCandidate.emailcampaigncount = 1
    }
  }


  getContactDetails(elasticid, emailPref) {
    return new Promise((resolve, reject) => {


      this.aiSourcingService.contactReveal(this.projectNumber, elasticid).subscribe(
        (res: any) => {
          if (res.status === 'success') {

            let personalPref_email = [];
            let professionalPref_email = [];
            let targetEmailFound = '';
            const existingContactDetails = res?.data.filter(x => x.type === 'email');
            if (existingContactDetails && existingContactDetails.length) {

              personalPref_email = existingContactDetails.filter(x => x.contactdetailcategory == 'personal')
              professionalPref_email = existingContactDetails.filter(x => x.contactdetailcategory == 'professional')

              switch (emailPref) {
                case 1: targetEmailFound = personalPref_email.length ? personalPref_email[0].contactdetail : '';
                  break;
                case 2: targetEmailFound = professionalPref_email.length ? professionalPref_email[0].contactdetail : '';
                  break;
                case 3: targetEmailFound = personalPref_email.length ? personalPref_email[0].contactdetail : professionalPref_email.length ? professionalPref_email[0].contactdetail : '';
                  break;
                case 4: targetEmailFound = professionalPref_email.length ? professionalPref_email[0].contactdetail : personalPref_email.length ? personalPref_email[0].contactdetail : '';
                  break;
              }
            }
            if (targetEmailFound) {
              resolve(targetEmailFound);
            } else {
              // reject("Primary email not found for the candidate.");
              resolve(null);
            }
          } else {
            reject("Error fetching contact details for the candidate.");
          }
        },
        (error) => {
          reject("An error occurred while fetching contact details.");
        }
      );
    });
  }

  onTypeAheadSearch(event: string): void {
    const query = event;
    this.emailCampaignService.getCampaigns({ campaign_name: query, created_by: this._localStorageService.getItem('userdata').userid, 'status[]': [1, 2] }).subscribe((data) => {
      this.campaignList = data['data'];
    });
  }

  changeCandidateStatus(data, status) {
    const modalRef = this.modalService.open(ArchiveCandidateModalComponent, { windowClass: 'genAimodal', centered: true, backdrop: 'static', keyboard: false });
    modalRef.componentInstance.data = data;
    modalRef.componentInstance.projectNumber = this.projectNumber;
                  modalRef.componentInstance.calledFrom = 'slider'

    modalRef.componentInstance.passEntry.subscribe((res: any) => {
      if (res === "success") {
        this.successMessage = 'Candidate successfully archived';
        setTimeout(() => {
          this.successMessage = '';
        }, 5000);
        this.getShortlistedProfiles();
      } else {
        this.errorMessage = 'Error occurred while archiving candidate';
        setTimeout(() => {
          this.errorMessage = '';
        }, 5000);
      }
    });
  }

  refreshList(res) {
    if (res && res.refresh === true) {
      this.getShortlistedProfiles();
    }
  }

  reEvaluateCriteria() {
    const payload = {
      "projectnumber": this.projectNumber,
      "candidatetype": "shortlisted"
    }
    this.aiSourcingService.reevaluateCriteria(payload).subscribe((res: any) => {
      if (res.status === 'success') {
        this.showShortlistRevaluate = 'started';
        this.projectDetails.shortlistedreevaluationstatus = 'started';
        this.aiSourcingHandlerService.setProjectDetails(this.projectDetails);
        this.successMessage = 'Re-evaluation started successfully';
        setTimeout(() => {
          this.successMessage = '';
        }, 5000);
      }
      else {
        this.errorMessage = 'Error occurred while re-evaluating criteria';
        setTimeout(() => {
          this.errorMessage = '';
        }, 5000);
      }
        /**
          * Click to re-evaluate
          */
         const emailCampaignParams = {
          "User ID": this._localStorageService.getItem('userdata').userid,
          "Project Number": this.projectNumber

        }
        clevertap.event.push("Autopilot-Re-evaluate - Shortlist Tab",emailCampaignParams);
    })
  }

  getProjectDetails(res) {
    this.projectDetails = res;
    this.showShortlistRevaluate = this.projectDetails?.shortlistedreevaluationstatus;
  }

  setPage(index: number) {
    this.currentPage = index;
    this.aiSourcingService.emitCandidateEvent(this.selectedCandididate);
    setTimeout(() => {
      this.getShortlistedProfiles();
    }, 0)
    this.document.documentElement.scrollTop = 0;
  }

  ngOnDestroy() {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }

  openEmailCampaignModal(campaign_id) {
    this.modalService.dismissAll();
    const modalRef = this.modalService.open(BulkEmailCampaignComponent, { size: 'xs' as 'lg', centered: true, backdrop: 'static', keyboard: false });
    modalRef.componentInstance.campaign_id = campaign_id;
  }

  addEmailCampaignActivity(data) {
    const payload = {
      "projectnumber": this.projectNumber,
      "action": "addtoemailcampaign",
      "elasticids": data.map(x => x.target_meta ? JSON.parse(x.target_meta).elastic_id : null),
      "activitydata": {
        "campaignname": this.selectedCampaign.campaign_name,
      }
    }

    this.aiSourcingService.aiSourcingEmailCampaignActivity(payload).subscribe((res: any) => {
      if (res.status === 'success') {
        console.log('Email campaign activity tracked successfully');
      } else {
        console.error('Error occurred while tracking email campaign activity');
      }
    });
  }
}
